/* HPR collection tag filters — 2026-09-08.
 * OR within a group, AND across groups. Complete, ordered collection pagination.
 */
(function() {
  'use strict';
  if (window.HPRCollectionFiltersMounted) return;
  window.HPRCollectionFiltersMounted = true;
  var controller = null;

  function createController(config, configNode) {
    var collectionUrl = config.collectionUrl;
    var legacyActiveTags = config.legacyActiveTags || [];
    var root = configNode.closest('[data-section-type="collection-template"]');
    var sectionId = root && root.getAttribute('data-section-id');
    var baseCardsCache = null;
    var destroyed = false;
    var productCache = null;
    var renderToken = 0;

    function uniq(list) {
      var out = [];
      (list || []).forEach(function(value) {
        value = String(value || '').trim();
        if (value && out.indexOf(value) === -1) out.push(value);
      });
      return out;
    }

    function tagPrefix(tag) {
      return String(tag || '').split('_')[0].trim();
    }

    function canonicalGroup(groupOrTag) {
      var value = String(groupOrTag || '').trim();
      var prefix = value.indexOf('_') > -1 ? tagPrefix(value) : value;
      var lower = prefix.toLowerCase();
      if (lower === 'tire width' || lower === 'tyre width') return 'Tyre Width';
      if (lower === 'tire profile' || lower === 'tyre profile' || lower === 'profile') return 'Tyre Profile';
      if (lower === 'diameter' || lower === 'tyre diameter' || lower === 'tire diameter' || lower === 'tyre size' || lower === 'tire size') return 'Tyre Size';
      return prefix;
    }

    function normaliseTags(tags) {
      if (!tags) return [];
      if (typeof tags === 'string') {
        return tags.split(',').map(function(tag) { return tag.trim(); }).filter(Boolean);
      }
      return tags.map(function(tag) { return String(tag || '').trim(); }).filter(Boolean);
    }

    function queryActiveTags() {
      var params = new URLSearchParams(window.location.search);
      var values = params.getAll('hprf');
      if (!values.length) return [];
      if (values.length === 1) {
        var packed = values[0] || '';
        if (packed.charAt(0) === '[') {
          try {
            var parsed = JSON.parse(packed);
            if (Array.isArray(parsed)) return uniq(parsed);
          } catch (e) {}
        }
      }
      return uniq(values);
    }

    function getActiveTags() {
      return new URLSearchParams(window.location.search).has('hprf') ? queryActiveTags() : uniq(legacyActiveTags);
    }

    function groupSelections(tags) {
      var groups = Object.create(null);
      uniq(tags).forEach(function(tag) {
        var group = canonicalGroup(tag);
        if (!groups[group]) groups[group] = [];
        if (groups[group].indexOf(tag) === -1) groups[group].push(tag);
      });
      return groups;
    }

    function urlForTags(tags) {
      var url = new URL(collectionUrl, window.location.origin);
      var oldParams = new URLSearchParams(window.location.search);
      oldParams.forEach(function(value, key) {
        if (key !== 'hprf' && key !== 'page' && key !== 'section_id' && key !== 'sections') url.searchParams.append(key, value);
      });
      var packedTags = uniq(tags);
      if (packedTags.length) url.searchParams.set('hprf', JSON.stringify(packedTags));
      return url.pathname + (url.search ? url.search : '') + (window.location.hash || '');
    }

    function navigateWithTags(tags) {
      window.location.href = urlForTags(tags);
    }

    window.HPRMultiFilter = {
      version: '2026-09-08',
      getActiveTags: getActiveTags,
      groupForTag: canonicalGroup,
      urlForTags: urlForTags,
      navigateWithTags: navigateWithTags,
      replaceGroups: function(groupsToReplace, newTags) {
        var removeGroups = (groupsToReplace || []).map(canonicalGroup);
        var next = getActiveTags().filter(function(tag) {
          return removeGroups.indexOf(canonicalGroup(tag)) === -1;
        });
        uniq(newTags).forEach(function(tag) {
          if (next.indexOf(tag) === -1) next.push(tag);
        });
        navigateWithTags(next);
      }
    };

    function productRecord(product) {
      return {
        handle: product.handle || '',
        tags: normaliseTags(product.tags)
      };
    }

    function fetchProducts() {
      if (productCache) return productCache;
      var products = [];
      var seen = Object.create(null);
      var base = collectionUrl.replace(/\/$/, '');
      function fetchPage(page) {
        return fetch(base + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
          .then(function(response) {
            if (!response.ok) throw new Error('Could not load the product index.');
            return response.json();
          })
          .then(function(data) {
            if (!data || !Array.isArray(data.products)) throw new Error('Invalid product index.');
            var added = 0;
            data.products.forEach(function(product) {
              if (product.handle && !seen[product.handle]) {
                seen[product.handle] = true;
                products.push(productRecord(product));
                added += 1;
              }
            });
            if (data.products.length === 250) {
              if (!added) throw new Error('Product index pagination did not advance.');
              return fetchPage(page + 1);
            }
            return products;
          });
      }
      productCache = fetchPage(1).catch(function(error) {
        productCache = null;
        throw error;
      });
      return productCache;
    }

    function productMatches(product, selections) {
      var groups = Object.keys(selections || {});
      for (var i = 0; i < groups.length; i += 1) {
        var options = selections[groups[i]] || [];
        if (!options.length) continue;
        var matched = false;
        for (var j = 0; j < options.length; j += 1) {
          if (product.tags.indexOf(options[j]) !== -1) {
            matched = true;
            break;
          }
        }
        if (!matched) return false;
      }
      return true;
    }

    function countForTag(products, optionTag, optionGroup, activeTags) {
      var activeGroups = groupSelections(activeTags);
      var group = canonicalGroup(optionGroup || optionTag);
      delete activeGroups[group];
      activeGroups[group] = [optionTag];
      return products.filter(function(product) { return productMatches(product, activeGroups); }).length;
    }

    function ensureFilterGroups(products, sidebar, active) {
      // Recover missing Liquid tag groups using the same public product index as the counts.
      var template = root && root.querySelector('[data-hpr-filter-group-template]');
      var area = sidebar.querySelector('.category-filters-area');
      if (!template || !area) return;
      var tags = uniq(products.reduce(function(all, product) { return all.concat(product.tags); }, []));
      var configured = String(config.groupOrder || '').split(',').map(function(group) { return group.trim(); }).filter(Boolean);
      var groups = configured.length ? uniq(configured) : uniq(tags.filter(function(tag) { return tag.indexOf('_') > 0; }).map(tagPrefix));
      var existing = uniq(Array.prototype.map.call(sidebar.querySelectorAll('[data-hpr-filter-item]'), function(item) { return item.getAttribute('data-group'); }));
      var hasTyreSize = tags.some(function(tag) { return tagPrefix(tag) === 'Tyre Size'; });
      groups.forEach(function(group) {
        if (existing.indexOf(group) !== -1 || (group === 'Diameter' && hasTyreSize)) return;
        var options = tags.filter(function(tag) { return tag.indexOf('_') > 0 && tagPrefix(tag) === group; });
        if (!options.length) return;
        options.sort(function(a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
        var block = template.content.firstElementChild.cloneNode(true);
        var title = block.querySelector('.category-filters-section-title');
        var list = block.querySelector('ul');
        block.querySelector('[data-hpr-group-title]').textContent = group === 'Tyre Size' ? 'Diameter' : group;
        function toggle() {
          var open = title.getAttribute('aria-expanded') !== 'true';
          title.setAttribute('aria-expanded', String(open));
          title.classList.toggle('active', open);
          list.classList.toggle('active', open);
          list.style.height = open ? 'auto' : '0px';
          list.style.display = open ? '' : 'none';
        }
        title.addEventListener('click', toggle);
        title.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
        });
        options.forEach(function(tag) {
          var item = document.createElement('li');
          item.className = 'advanced-filter';
          item.setAttribute('data-hpr-filter-item', '');
          item.setAttribute('data-group', group);
          item.classList.toggle('active-filter', active.indexOf(tag) !== -1);
          var link = document.createElement('a');
          var label = tag.slice(tag.indexOf('_') + 1).trim();
          link.textContent = group === 'Tyre Size' ? label.replace(/^[Rr]/, '') : label;
          link.href = urlForTags([tag]);
          link.className = 'hpr-group-filter-link';
          link.setAttribute('data-hpr-filter-tag', tag);
          link.setAttribute('data-hpr-filter-group', group);
          var count = document.createElement('span');
          count.className = 'hpr-filter-count';
          count.setAttribute('data-hpr-filter-count', '');
          count.setAttribute('data-tag', tag);
          item.appendChild(link);
          item.appendChild(document.createTextNode(' '));
          item.appendChild(count);
          list.appendChild(item);
        });
        area.appendChild(block);
      });
    }

    function updateFilterUI() {
      var active = getActiveTags();
      var sidebar = document.querySelector('.collection-sidebar');
      if (!sidebar) return;

      sidebar.querySelectorAll('[data-hpr-filter-item]').forEach(function(item) {
        var link = item.querySelector('[data-hpr-filter-tag]');
        var tag = link ? (link.getAttribute('data-hpr-filter-tag') || '') : '';
        item.classList.toggle('active-filter', active.indexOf(tag) !== -1);
      });

      var clear = sidebar.querySelector('[data-hpr-active-filters]');
      if (clear) clear.style.display = active.length ? '' : 'none';

      fetchProducts().then(function(products) {
        if (destroyed) return;
        ensureFilterGroups(products, sidebar, active);
        sidebar.querySelectorAll('[data-hpr-filter-count]').forEach(function(node) {
          var tag = node.getAttribute('data-tag') || '';
          var item = node.closest('[data-hpr-filter-item]');
          var group = item ? (item.getAttribute('data-group') || canonicalGroup(tag)) : canonicalGroup(tag);
          var count = countForTag(products, tag, group, active);
          var isActive = active.indexOf(tag) !== -1;
          node.textContent = '(' + count + ')';
          node.setAttribute('data-hpr-live-count', String(count));
          if (item) {
            item.classList.toggle('hpr-filter-option--unavailable', count === 0 && !isActive);
            item.setAttribute('aria-disabled', count === 0 && !isActive ? 'true' : 'false');
          }
        });
      }).catch(function() {});
    }

    function pageUrl(page) {
      var url = new URL(collectionUrl, window.location.origin);
      new URLSearchParams(window.location.search).forEach(function(value, key) {
        if (key !== 'hprf' && key !== 'page' && key !== 'section_id' && key !== 'sections') {
          url.searchParams.append(key, value);
        }
      });
      url.searchParams.set('page', String(page));
      // Request this section only; don't download the header, footer and apps again.
      if (sectionId) url.searchParams.set('section_id', sectionId);
      return url.pathname + url.search;
    }

    function parseCards(doc) {
      var collectionRoot = doc.querySelector('[data-section-type="collection-template"]');
      var wrapper = doc.querySelector('#Collection .Collection-wrapper');
      if (!wrapper) throw new Error('The collection page could not be loaded.');
      var pages = parseInt(collectionRoot && collectionRoot.getAttribute('data-hpr-page-count'), 10) || 1;
      var total = parseInt(collectionRoot && collectionRoot.getAttribute('data-hpr-total-products'), 10);
      var current = parseInt(collectionRoot && collectionRoot.getAttribute('data-hpr-current-page'), 10) || 1;
      var next = 0;
      // Also support older numbered pagination and the load-more/scroll modes.
      doc.querySelectorAll('#Collection ul.pagination a[href], #Collection #AjaxinatePagination a[href]').forEach(function(link) {
        var page = parseInt(new URL(link.getAttribute('href'), window.location.origin).searchParams.get('page'), 10);
        if (page > pages) pages = page;
        if (page > current && (!next || page < next)) next = page;
      });
      var nextHref = collectionRoot && collectionRoot.getAttribute('data-hpr-next-page');
      if (nextHref) next = parseInt(new URL(nextHref, window.location.origin).searchParams.get('page'), 10) || next;
      return {
        cards: Array.prototype.map.call(wrapper.querySelectorAll('.product-item-block'), function(card) { return card.cloneNode(true); }),
        pages: pages,
        total: total,
        next: next
      };
    }

    function cardKey(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) throw new Error('A product card is missing its product link.');
      return new URL(link.getAttribute('href'), window.location.origin).pathname.split('/products/')[1].split('/')[0];
    }

    function mapLimited(items, worker) {
      var output = new Array(items.length);
      var cursor = 0;
      function run() {
        if (destroyed) throw new Error('Collection was unloaded.');
        var index = cursor++;
        if (index >= items.length) return Promise.resolve();
        return worker(items[index]).then(function(value) { output[index] = value; return run(); });
      }
      return Promise.all(Array.from({ length: Math.min(3, items.length) }, run)).then(function() { return output; });
    }

    function fetchCardPage(page) {
      return fetch(pageUrl(page), { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('A collection page could not be loaded.');
          return response.text();
        })
        .then(function(html) { return parseCards(new DOMParser().parseFromString(html, 'text/html')); });
    }

    function fetchAllCards() {
      if (baseCardsCache) return baseCardsCache;
      var basePath = new URL(collectionUrl, window.location.origin).pathname.replace(/\/$/, '');
      var currentPage = parseInt(new URLSearchParams(window.location.search).get('page'), 10) || 1;
      var canReuse = window.location.pathname.replace(/\/$/, '') === basePath && currentPage === 1 && !legacyActiveTags.length;
      var firstPage = canReuse ? Promise.resolve().then(function() { return parseCards(document); }) : fetchCardPage(1);
      baseCardsCache = firstPage.then(function(first) {
        var pageNumbers = [];
        for (var page = 2; page <= first.pages; page += 1) pageNumbers.push(page);
        return mapLimited(pageNumbers, fetchCardPage).then(function(pages) {
          var allPages = [first].concat(pages);
          // A load-more response without metadata reveals only one next page at a time.
          function followNext() {
            var last = allPages[allPages.length - 1];
            if (last.next > allPages.length) {
              return fetchCardPage(last.next).then(function(result) { allPages.push(result); return followNext(); });
            }
            var seen = Object.create(null);
            var cards = [];
            allPages.forEach(function(result) {
              result.cards.forEach(function(card) {
                var key = cardKey(card);
                if (!seen[key]) { seen[key] = true; cards.push(card); }
              });
            });
            if (!isNaN(first.total) && cards.length !== first.total) throw new Error('Some collection products are missing.');
            return cards;
          }
          return followNext();
        });
      }).catch(function(error) { baseCardsCache = null; throw error; });
      return baseCardsCache;
    }

    function extractMatchingCards(activeTags) {
      var selections = groupSelections(activeTags);
      return Promise.all([fetchProducts(), fetchAllCards()]).then(function(results) {
        var wanted = Object.create(null);
        results[0].forEach(function(product) {
          if (productMatches(product, selections)) wanted[product.handle] = true;
        });
        // Keep Shopify's server-rendered order for Featured, Best selling and price sorts.
        var cards = results[1].filter(function(card) { return !!wanted[cardKey(card)]; });
        if (cards.length !== Object.keys(wanted).length) throw new Error('Some matching products could not be loaded.');
        return cards;
      });
    }

    function setLoading(loading) {
      var section = document.querySelector('.Collection_Section');
      var wrapper = document.querySelector('#Collection .Collection-wrapper');
      if (!section || !wrapper) return;
      section.classList.toggle('hpr-multifilter-loading', !!loading);
      wrapper.setAttribute('aria-busy', loading ? 'true' : 'false');
      var error = document.querySelector('[data-hpr-filter-error]');
      if (loading && error) error.remove();
      var status = document.querySelector('[data-hpr-filter-status]');
      if (loading && !status) {
        status = document.createElement('div');
        status.setAttribute('data-hpr-filter-status', '');
        status.className = 'hpr-filter-status';
        status.setAttribute('role', 'status');
        status.textContent = 'Filtering products…';
        wrapper.parentNode.insertBefore(status, wrapper);
      } else if (!loading && status) {
        status.parentNode.removeChild(status);
      }
    }

    function updateProductCount(count) {
      document.querySelectorAll('.filters-toolbar__product-count').forEach(function(node) {
        node.textContent = count + (count === 1 ? ' product' : ' products');
      });
    }

    function reinitialiseProductCards(wrapper) {
      if (!wrapper) return;
      if (window.theme && typeof theme.AddItemToCart === 'function') {
        wrapper.querySelectorAll('[action="/cart/add"]').forEach(function(form) {
          try { theme.AddItemToCart(form); } catch (e) {}
        });
      }
      if (window.theme && typeof theme.ProductItemSwatches === 'function') {
        try { theme.ProductItemSwatches(); } catch (e) {}
      }
    }

    function renderFilteredProducts() {
      var active = getActiveTags();
      if (!active.length) return;
      var wrapper = document.querySelector('#Collection .Collection-wrapper');
      if (!wrapper) return;
      var token = ++renderToken;
      setLoading(true);

      extractMatchingCards(active).then(function(cards) {
        if (destroyed || token !== renderToken) return;
        var seen = {};
        var html = [];
        cards.forEach(function(card, index) {
          var key = cardKey(card);
          if (!seen[key]) {
            seen[key] = true;
            var displayCard = card.cloneNode(true);
            displayCard.querySelectorAll('img').forEach(function(image) {
              image.setAttribute('loading', 'lazy');
              image.setAttribute('fetchpriority', 'low');
            });
            var primaryImage = displayCard.querySelector('img[data-image]');
            if (primaryImage && index < 4) {
              primaryImage.setAttribute('loading', 'eager');
              primaryImage.setAttribute('fetchpriority', index === 0 ? 'high' : 'auto');
            }
            html.push(displayCard.outerHTML);
          }
        });
        wrapper.innerHTML = html.join('');
        wrapper.hidden = false;
        wrapper.classList.add('hpr-filter-results-ready');
        wrapper.classList.toggle('grid--view-items', html.length > 0);

        var oldEmpty = document.querySelector('#Collection > .grid__item.small--text-center');
        if (oldEmpty) oldEmpty.style.display = 'none';
        var existingEmpty = document.querySelector('[data-hpr-filter-empty]');
        if (existingEmpty) existingEmpty.parentNode.removeChild(existingEmpty);
        if (!html.length) {
          var empty = document.createElement('div');
          empty.setAttribute('data-hpr-filter-empty', '');
          empty.className = 'grid__item small--text-center hpr-filter-empty';
          empty.innerHTML = '<p class="text-center">Sorry, there are no products matching these filters.</p>';
          wrapper.parentNode.appendChild(empty);
        }

        document.querySelectorAll('#Collection ul.pagination, #Collection #AjaxinatePagination').forEach(function(pagination) { pagination.style.display = 'none'; });
        updateProductCount(html.length);
        reinitialiseProductCards(wrapper);
        setLoading(false);
      }).catch(function() {
        if (destroyed || token !== renderToken) return;
        setLoading(false);
        wrapper.hidden = true;
        document.querySelectorAll('#Collection ul.pagination, #Collection #AjaxinatePagination').forEach(function(node) { node.style.display = 'none'; });
        document.querySelectorAll('.filters-toolbar__product-count').forEach(function(node) { node.textContent = ''; });
        var error = document.createElement('div');
        error.setAttribute('data-hpr-filter-error', '');
        error.setAttribute('role', 'alert');
        error.className = 'hpr-filter-status';
        error.innerHTML = '<p>We couldn’t load all matching products. Please try again.</p><button type="button" class="btn btn--secondary" data-hpr-filter-retry>Try again</button>';
        wrapper.parentNode.insertBefore(error, wrapper);
      });
    }

    function onClick(event) {
        if (event.target.closest('[data-hpr-filter-retry]')) {
          event.preventDefault();
          renderFilteredProducts();
          updateFilterUI();
          return;
        }
        var clear = event.target.closest('[data-hpr-clear-filters]');
        if (clear) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var url = new URL(collectionUrl, window.location.origin);
          var params = new URLSearchParams(window.location.search);
          params.forEach(function(value, key) {
            if (key !== 'hprf' && key !== 'page' && key !== 'section_id' && key !== 'sections') url.searchParams.append(key, value);
          });
          window.location.href = url.pathname + url.search;
          return;
        }

        var link = event.target.closest('[data-hpr-filter-tag]');
        if (!link) return;
        var item = link.closest('[data-hpr-filter-item]');
        if (item && item.classList.contains('hpr-filter-option--unavailable') && !item.classList.contains('active-filter')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        var tag = link.getAttribute('data-hpr-filter-tag') || '';
        var active = getActiveTags();
        var index = active.indexOf(tag);
        if (index > -1) active.splice(index, 1);
        else active.push(tag);
        navigateWithTags(active);
    }

    function migrateLegacyUrl() {
      if (queryActiveTags().length || !legacyActiveTags.length) return;
      try { window.history.replaceState({}, '', urlForTags(legacyActiveTags)); } catch (e) {}
    }

    function init() {
      migrateLegacyUrl();
      document.addEventListener('click', onClick, true);
      document.addEventListener('hpr:tyre-search-changed', updateFilterUI);
      // Active filters must resolve immediately; unfiltered counts can wait for first paint.
      if (getActiveTags().length) {
        updateFilterUI();
        renderFilteredProducts();
      } else if (document.readyState === 'complete') {
        scheduleCounts();
      } else {
        window.addEventListener('load', scheduleCounts, { once: true });
      }
    }
    function scheduleCounts() {
      if (destroyed) return;
      if ('requestIdleCallback' in window) window.requestIdleCallback(function() { if (!destroyed) updateFilterUI(); }, { timeout: 2000 });
      else setTimeout(function() { if (!destroyed) updateFilterUI(); }, 0);
    }
    init();
    return {
      node: configNode,
      destroy: function() {
        destroyed = true;
        renderToken += 1;
        document.removeEventListener('click', onClick, true);
        document.removeEventListener('hpr:tyre-search-changed', updateFilterUI);
        window.removeEventListener('load', scheduleCounts);
      }
    };
  }

  function mount() {
    var node = document.querySelector('[data-hpr-filter-config]');
    if (controller && controller.node === node) return;
    if (controller) { controller.destroy(); controller = null; }
    if (!node) return;
    var config;
    try { config = JSON.parse(node.textContent); } catch (error) { return; }
    controller = createController(config, node);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function(event) {
    if (controller && event.target.contains(controller.node)) { controller.destroy(); controller = null; }
  });
})();
